import {
  FileBox,
  FirstDiv, LabelFile,
  LabelSelecionado, GuideText, BoxIntegracao, BoxHeader
}
  from './styles'
import { FaDownload, FaEye, FaFolder, FaMinusCircle } from 'react-icons/fa'
import { useEffect, useState } from 'react'
import { iItemIntegracao } from '../../../../../interfaces'
import { Button, Flex, FormControl, FormLabel, Image, Input, useToast } from '@chakra-ui/react'
import { appApi } from '../../../../../services/appApi'
import { useNavigate } from 'react-router-dom'
import { EditorTexto } from '../../../../../components/EditorTexto/Index'

interface iCardProps {
  position: number
  id: string
  ItemIntegracao: iItemIntegracao
  onDelete: (id: string) => void
  onUpdateInput: (item: iItemIntegracao) => void
}

export const CardImagem: React.FC<iCardProps> = ({ ItemIntegracao, id, position, onDelete, onUpdateInput }) => {
  const toast = useToast()
  const nav = useNavigate()

  const [IsLoading, setIsLoading] = useState(false)

  const [Titulo, setTitulo] = useState('')
  const [Descricao, setDescricao] = useState('')
  const [Arquivo, setArquivo] = useState('')

  const [Tamanho, setTamanho] = useState('')
  const [NomeArquivo, setNomeArquivo] = useState('')

  useEffect(() => {
    if (ItemIntegracao.descricao !== undefined) {
      setIsLoading(true)
      setDescricao(ItemIntegracao.descricao)
    }
    setTitulo(ItemIntegracao.titulo)

    if (ItemIntegracao.arquivo !== null) {
      if (ItemIntegracao.arquivo !== undefined) {
        setArquivo(ItemIntegracao.arquivo.uri)
        setTamanho(ItemIntegracao.arquivo.size)
        setNomeArquivo(ItemIntegracao.arquivo.name)
      }
    }
  }, [])

  const AtualizarArquivo = (event: any): void => {
    const formdata = new FormData()
    formdata.append('request', event.target.files[0])

    appApi.post(`ImersaoExterna/${id}/Item/${ItemIntegracao.id}/uploadfile`, formdata)
      .then(resposnse => {
        setTamanho(resposnse.data.size)
        setArquivo(resposnse.data.uri)
        setNomeArquivo(resposnse.data.name)
        toast({
          title: 'Arquivo cadastrado com sucesso',
          status: 'success',
          isClosable: false
        })
      }).catch(e => console.log(e))
  }

  return (
    <BoxIntegracao>
      <BoxHeader>
        <span>{position}. Arquivo de imagem</span>
        <FaMinusCircle onClick={() => onDelete(ItemIntegracao.id)}/>
      </BoxHeader>
      <Flex margin={'1rem 0rem 1rem 0rem'}>
        <FirstDiv>
          {
            <FileBox>
              {
                Arquivo.length === 0
                  ? <>
                    <FaDownload color='var(--c7)' size={35} />
                    <GuideText>Arraste e solte o arquivo de imagem para fazer o envio</GuideText>
                    <small>(JPG ou PNG)</small>
                    <input id={ItemIntegracao.id} type={'file'} onChange={(e) => { AtualizarArquivo(e) }} />
                    <LabelFile theme={'4578D6'} htmlFor={ItemIntegracao.id}><FaFolder />Selecionar arquivo</LabelFile>
                  </>
                  : <>
                    <Flex marginBottom={'1rem'}>
                        <Image boxSize='130px'
                          objectFit='scale-down'
                          src={Arquivo}
                          alt={NomeArquivo}
                          marginRight={'1rem'}
                          border={'2px solid var(--Gray3)'}
                        />
                      <Flex flexDir={'column'}>
                        <span>{NomeArquivo}</span>
                        <small>Tamanho:{Tamanho}</small>
                      </Flex>
                    </Flex>
                    <div>
                      <input id={ItemIntegracao.id} type={'file'} onChange={(e) => { AtualizarArquivo(e) }} />
                      <LabelSelecionado htmlFor={ItemIntegracao.id}><FaFolder />Selecionar arquivo</LabelSelecionado>
                    </div>
                  </>
              }
            </FileBox>
          }
        </FirstDiv>

        <Flex width={'100%'} height={'100%'} flexDirection={'column'}>
          <FormControl>
            <FormLabel fontSize={'lg'}>Título</FormLabel>
            <Input
              value={Titulo}
              borderColor={'var(--Gray4)'}
              onChange={(e) => { setTitulo(e.target.value) }}
              type="text"
              placeholder='Propósito, missão, visão, valores'
              onBlur={() => onUpdateInput({
                id: ItemIntegracao.id,
                titulo: Titulo,
                descricao: Descricao,
                tipo: ItemIntegracao.tipo
              })}
            />
          </FormControl>

          <FormControl height={'100%'} marginTop={'1rem'}>
            <FormLabel fontSize={'lg'} >Descrição</FormLabel>
            <EditorTexto
              isLoading={IsLoading}
              initialValue={Descricao}
              placeholder='Deixe um texto para aparecer junto o video'
              className='editorSt-v2'
              onChange={(e: string) => { setDescricao(e) }}
              onBlur={() => onUpdateInput({
                id: ItemIntegracao.id,
                titulo: Titulo,
                descricao: Descricao,
                tipo: ItemIntegracao.tipo
              })}
            />
          </FormControl>
        </Flex>
      </Flex>

      <Flex justifyContent={'end'}>
        <Button
          leftIcon={<FaEye />}
          fontWeight={'500'}
          borderRadius={'12px'}
          bg={'var(--Rosa)'}
          _hover={{ bg: 'var(--Rosa)' }}
          onClick={() => nav(`Item/${ItemIntegracao.id}`)}
        >Pré-visualizar</Button>
      </Flex>
    </BoxIntegracao>
  )
}
